(function () {
    'use strict';

    angular.module('swif.framework')
        .factory('swifModal', swifModal);

    /**
     * @ngdoc service
     * @name swif.framework.swifModal
     * @description open a modal
     * @requires ui.bootstrap.modal:$uibModal
     * @requires swif.framework:swifSettingsService
     * @example
     * ```js
        var modalConfig = angular.copy(action.modal);
        modalConfig.contentType = contentType;
        modalConfig.action = action;
        modalConfig.model = model;
        modalConfig.preValidate = options.preValidate; //done by modal
        modalConfig.options = options;
        swifModal.open(modalConfig);
     * ```
     **/
    function swifModal($uibModal, settings) {
        'ngInject';
        return {
            /**
             * Open a modal
             * @param {
             *      title: the title of the modal
             *      templateUrl: url of a template to load
             *      controller: name of the controller to attach
             *      model: the model that will be passed to the controller
             * }
             * All the others properties will be accessible throw 'modalParams'
             * in the template
             * @return a modal instance (from angular-ui-bootstrap)
             */
            open: function (params) {
                var options = angular.copy(settings.app.defaultValues.modal);
                _.assign(options,
                    {
                        templateUrl: 'partials/framework/modal.html',
                        controller: 'ModalController',
                        size: params.size,
                        scope: params.scope,
                        resolve: {
                            modalParams: function () {
                                return params;
                            }
                        }
                    }
                );
                return $uibModal.open(options);
            }
        };
    }
})();
